import { GetLoanApplicationResponse } from 'api/typegen/client/application/get';
import { QueryStatus } from '@tanstack/react-query';
import getLoanApplicationApiCall from 'api/calls/getLoanApplicationApiCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

interface UseLoanApplicationQuery {
  status: QueryStatus;
  isFetching: boolean;
  loanApplication?: GetLoanApplicationResponse;
}

/**
 * TODO: headers: {
        //       Accept: 'application/vnd.4finance.web.v1.hal+json',
        //       'Content-Type': 'application/vnd.4finance.web.v1.hal+json',
        //     }
 */
const useLoanApplicationQuery = (enabled = true): UseLoanApplicationQuery => {
  const { token } = useAuth();
  const query = useProtectedQuery(
    ['getLoanApplicationApiCall', token],
    getLoanApplicationApiCall,
    {
      enabled,
    },
  );

  return {
    status: query.status,
    isFetching: query.isFetching,
    loanApplication: query.data,
  };
};

export default useLoanApplicationQuery;
